import styles from './CarouselButtons.module.css';

interface Props {
  changeSelectedIndex: (delta: number) => void;
  dropShadow?: boolean;
}

const CarouselButtons = (props: Props) => {
  return (
    <>
      <button
        className={
          styles.carouselButton +
          ' ' +
          styles.carouselButtonPrevious +
          (props.dropShadow ? ' ' + styles.withDropShadow : '')
        }
        onClick={() => props.changeSelectedIndex(-1)}
      >
        <svg width="6" height="10" viewBox="0 0 11 24" fill="none">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.73021 12.3435C6.85507 11.2839 6.01403 10.2663 5.17352 9.24793C3.63085 7.37882 2.08832 5.5095 0.546171 3.6397C0.179329 3.19494 0.0531962 2.66477 0.203234 2.06101C0.348412 1.47714 0.684826 1.12056 1.17495 1.00135C1.63155 0.890251 2.02186 1.06767 2.34934 1.46425C3.43305 2.77682 4.51873 4.08689 5.60205 5.39989C7.17541 7.30677 8.74746 9.21541 10.3199 11.1234C10.9445 11.8812 10.9465 12.7658 10.3209 13.5242C7.66983 16.7386 5.01902 19.9532 2.36514 23.1641C1.63155 24.0518 0.468372 23.7302 0.196054 22.5639C0.0604638 21.983 0.174207 21.4625 0.530979 21.0302C2.85772 18.2106 5.18451 15.3911 7.51213 12.5724C7.5736 12.498 7.64357 12.4339 7.73021 12.3435Z"
          />
        </svg>
      </button>

      <button
        className={
          styles.carouselButton +
          ' ' +
          styles.carouselButtonNext +
          (props.dropShadow ? ' ' + styles.withDropShadow : '')
        }
        onClick={() => props.changeSelectedIndex(1)}
      >
        <svg width="6" height="10" viewBox="0 0 11 24" fill="none">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.73021 12.3435C6.85507 11.2839 6.01403 10.2663 5.17352 9.24793C3.63085 7.37882 2.08832 5.5095 0.546171 3.6397C0.179329 3.19494 0.0531962 2.66477 0.203234 2.06101C0.348412 1.47714 0.684826 1.12056 1.17495 1.00135C1.63155 0.890251 2.02186 1.06767 2.34934 1.46425C3.43305 2.77682 4.51873 4.08689 5.60205 5.39989C7.17541 7.30677 8.74746 9.21541 10.3199 11.1234C10.9445 11.8812 10.9465 12.7658 10.3209 13.5242C7.66983 16.7386 5.01902 19.9532 2.36514 23.1641C1.63155 24.0518 0.468372 23.7302 0.196054 22.5639C0.0604638 21.983 0.174207 21.4625 0.530979 21.0302C2.85772 18.2106 5.18451 15.3911 7.51213 12.5724C7.5736 12.498 7.64357 12.4339 7.73021 12.3435Z"
          />
        </svg>
      </button>
    </>
  );
};

export default CarouselButtons;
